<template> 
    <div>        
        <div class="d-flex flex-stack flex-wrap">
            <div class="page-title d-flex flex-column me-3 mt-3"> 
                <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('recosting') }}</h1>  
                <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                    <li class="breadcrumb-item text-gray-600">
                        <a href="#" class="text-gray-600 text-hover-primary">
                            <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                        </a>
                    </li> 
                    <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">{{ $t('settings') }}</router-link></li>     
                    <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'RecalculationOperations' }">{{ $t('recalculation_operations') }}</router-link></li> 
                    <li class="breadcrumb-item text-gray-600">{{ $t('recosting') }}
                        <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                    </li> 
                </ul> 
            </div>  
            <div class="d-flex align-items-center py-1">
                <router-link to="/RecalculationOperations">
                    <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                    <span class="ms-2 fs-7"> {{ $t('return_back_to_recalculation') }}</span>
                    </button>
                </router-link> 
            </div>
        </div>
        <div class="content flex-row-fluid mt-4" id="kt_content">
            <div class="card">
                <div class="card-body">
                    <div class="row fv-row">
                        <div class="col-lg-12">
                            <div class="fv-row mb-4 row">
                                <div class="col-lg" v-if="userData.is_online_accounting == 1 && this.$isModuleActive(5) && this.$isCredentialActive(4,'')">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>{{ $t('accounting_period') }}</span>
                                    </label>
                                    <Select2 v-model="form.period_id" :options="accountingYears" :settings="{ width: '100%' }"
                                        @select="onChangeAccountingYear($event)" />
                                </div>
                                <div class="col-lg">
                                    <label class="fs-6 form-label mt-3">
                                        <span>{{ $t('start_date') }}</span>
                                    </label>
                                    <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'"
                                        v-model="form.first_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply
                                        :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'"
                                        :enableTimePicker="false" :minDate="this.form.periodSelection.start_date"
                                        :maxDate="this.form.periodSelection.end_date"></Datepicker>
                                </div>
                                <div class="col-lg">
                                    <label class="fs-6 form-label mt-3">
                                        <span>{{ $t('end_date') }}</span>
                                    </label>
                                    <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'"
                                        v-model="form.last_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply
                                        :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'"
                                        :enableTimePicker="false" :minDate="this.form.periodSelection.start_date"
                                        :maxDate="this.form.periodSelection.end_date"></Datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 mt-10">
                            <div class="d-grid gap-2">
                                <div class="btn-group"> 
                                    <button type="button" class="btn btn-light-success border border-success rounded" @click="onStartCalculation()" data-kt-indicator="on">
                                        <span class="svg-icon svg-icon-muted svg-icon-1">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3"
                                                    d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z"
                                                    fill="currentColor" />
                                                <path
                                                    d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z"
                                                    fill="currentColor" />
                                            </svg>
                                        </span>
                                        <span v-if="!this.isProgressing"> {{ $t('start_recosting') }} </span>
                                        <span class="indicator-progress" v-if="this.isProgressing">
                                            {{ $t('saving') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span>
                                    </button>
                                    <div class="d-flex justify-content-end ms-5" data-kt-customer-table-toolbar="base">
                                        <Popper hover placement="top">
                                            <button type="button" class="btn btn-light border border-gray-300 btn-icon" @click="this.setCriteriasToDefault()">
                                                <i class="bi bi-eraser-fill fs-4"> </i>
                                            </button>
                                            <template #content>
                                                <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                                            </template>
                                        </Popper> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import moment from 'moment';

  export default {
    name: 'ReCosting',
    data() {
        return {
            userData: this.$getUser(),
            form:  {
                first_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                last_date: moment(),
                period_id: '-1',
                periodSelection: {},
                cost_of_sales: 1,
                cost_of_sales_method: 1,
            },
            isProgressing: false,
            menuSelection: '/Re-CostingHelppage',
            iconView : false,
            accountingYears: [{ id: '-1', text: this.$t('select_an_option')}],            
            costOfSalesMethodList: [
                { id: 1, text: this.$t('first_in_first_out')},
                { id: 2, text: this.$t('moving_average_cost')}, /* hareketli ağırlıklı ortalama maliyet */
            ],
        };
    },
    computed: {        
        costOfSalesMethodName(){
            return this.costOfSalesMethodList.find(element => {
                return element.id == this.form.cost_of_sales_method
            }).text;
        },
    },
    methods: {
        getData() {
            this.accountingYears = [{ id: '-1', text: this.$t('select_an_option')}];
            const params = {
                session_id: this.$getUser().session_id
            };
            axios.post('/api/CostsSettings/GetCostSettings', params, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){   
                    this.form.cost_of_sales = response.data.cost_of_sales;
                    this.form.cost_of_sales_method = response.data.cost_of_sales_method;
                }
                this.getAccountingYears();
            })
            .catch((error) => {
                console.error(error);
                this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");   
            });
        },
        getAccountingYears() {
            if(this.userData.is_online_accounting !== 1 || !this.$isModuleActive(5) || !this.$isCredentialActive(4,'')) return;
            const parameters = {
                session_id: this.$getUser().session_id
            };  
            axios.post('/api/Auth/GetCompanyAccountingYears', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.accountingYears = response.data; 
                    if(this.accountingYears.length > 0) {
                        this.accountingYears.forEach((period) => {
                            if(period.id == this.$getSessionStorage('activeYear')){
                                this.form.period_id = period.id;
                                this.form['periodSelection'] = period; 
                                this.form.first_date = moment(this.form['periodSelection'].start_date); 
                                this.form.last_date = moment(this.form['periodSelection'].end_date); 
                                this.form.cost_of_sales = response.data.cost_of_sales;
                                this.form.cost_of_sales_method = response.data.cost_of_sales_method;
                            } 
                        });
                    }
                    this.accountingYears.unshift({ id: '-1', text: this.$t('select_an_option')});
                }
            })
            .catch((error) => {
               console.error(error);
            }); 
        },
        onChangeAccountingYear(e){
            this.form['periodSelection'] = e;
            this.form.first_date = moment(this.form['periodSelection'].start_date); 
            this.form.last_date = moment(this.form['periodSelection'].end_date); 
        },
        setCriteriasToDefault() {   
            this.form = {
              periodSelection: {},
              first_date: moment(),
              last_date: moment(),
            };
            this.lists = [];
            this.accountingYears.forEach((period) => {
                if(period.id == this.$getSessionStorage('activeYear')){
                    this.form.period_id = period.id;
                    this.form['periodSelection'] = period; 
                    this.form.first_date = moment(this.form['periodSelection'].start_date); 
                    this.form.last_date = moment(this.form['periodSelection'].end_date); 
                } 
            });
        },
        onStartCalculation() {
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_start_cost_calculation'),
                confirmButtonColor: "#50cd89",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('confirm'),
                icon: 'info'
            })
            .then((result) => {
                if (result.isConfirmed) { 
                    this.isProgressing = true;
                    const params = {
                        session_id: this.$getUser().session_id,
                        start_date: moment(this.form.first_date).format('YYYY-MM-DD[T]HH:mm:ss'),
                        end_date: moment(this.form.last_date).format('YYYY-MM-DD[T]HH:mm:ss'),
                        period_id: this.userData.is_online_accounting == 1 ? (this.form.period_id !== '-1' ? this.form.period_id : null) : null,
                    };   
                    const that = this;
                    axios.post('api/ReCosting/StartCalculation', params, {'Content-Type': 'application/json'})
                    .then((response) => {
                        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){                            
                            this.lists = [];
                            this.$swal(this.$t('success'), this.$t('recosting_operation_completed_succesfully'), 'success');  
                        }
                    })
                    .finally(() => { 
                        setTimeout(() => {
                            that.isProgressing = false;
                        }, 500);
                    });  
                }
            });
        },
        async helpPageViewIcon()
        {
            const queryparameter = {
                session_id : this.$getUser().session_id,
                menu_selection : '/Re-CostingHelppage'
            };
            axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
            .then((response) => { 
                if(!response.data.error){ 
                    this.iconView = response.data;
                }
            })
        },         
    },
    created() { 
      this.helpPageViewIcon();
      this.getData();
    }
  }; 
  </script>